
import { useEffect, useState } from 'react';
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import EditForm from '../../utils/utilities/EditForm';

import { Grid } from '@mui/material';
import { fields, initialValues, schema, additionalState } from "./config";

import { useQuery } from '@tanstack/react-query';

import { getServiceCategories } from './apiService';

const EditService = () => {
  const [formFields, setFormFields] = useState([...fields.map(field => ({...field}))]);

  const { data: service_categories } = useQuery({
    queryKey: ['services/service_categories'],
    queryFn: getServiceCategories,
  })


  useEffect(() => {
    if (service_categories) {
      const updatedFields = formFields.map(field => {
        if (field.name === 'category') {
          return {
            ...field,
            serverOptions: service_categories
          };
        }
        return field;
      });
      setFormFields(updatedFields);
    }
  }, [service_categories]);

  return (
    <EditForm title={"Service"} initialValues={initialValues} fields={formFields} schema={schema} url={"services"} additionalState={additionalState}>
      
     </EditForm>
  );
}

export default EditService;